<template>
  <div>
    <BoolInput
      v-model="innerValue" />
  </div>
</template>
<script>
import BoolInput from '@components/input/UserActiveInput';
import { mapMutations } from 'vuex';

export default {
  name: 'UserActiveFilter',
  components: {
    BoolInput
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    field: {
      type: String,
      required: true
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.setFilter({ key: this.field, value: val });
        if (val === 1) {
          this.$emit('filter', () => () => true);
        } else if (val === 2) {
          this.$emit('filter', () => (x) => x[this.field]);
        } else {
          this.$emit('filter', () => (x) => !x[this.field]);
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setFilter: 'dataTableFilters/setFilter'
    })
  },
  mounted() {
    this.innerValue = this.$store.state.dataTableFilters.filters[this.field] || this.value;
  }
};
</script>
<style>

</style>
